import { connectAssets } from '@exodus/assets'
import { keyBy } from '@exodus/basic-utils'
import { Api } from '@exodus/solana-api'
import { createSolanaAssetFactory } from '@exodus/solana-plugin'
import assetList, { asset } from '@exodus/solanatestnet-meta'

const rpcUrl = 'https://solana-testnet.a.exodus.io'

const assets = connectAssets(keyBy(assetList, (asset) => asset.name))

const serverApi = new Api({ rpcUrl, assets, tokenAssetType: asset.tokenAssetType })

const createAsset = createSolanaAssetFactory({ assetList, serverApi, isTestnet: true })

const defaultExport = { createAsset }

export default defaultExport
